import ToolWorkspacePage from "./ToolWorkspacePage";
import VehicleKmDriverPage from "./VehicleKmDriverPage";
import FuelWorkspacePage from "./FuelWorkspacePage";
import PackagingWorkspacePage from "./PackagingWorkspacePage";

// Functional parity split from App.js; only selects the existing tool page component.
export default function ToolPageHost({
  activeToolPageDefinition,
  canDeleteVehicleRecords,
  currentUserId,
  currentUserName,
  isOnline,
  onBack,
  projects,
  selectedProjectId,
}) {
  if (!activeToolPageDefinition) return null;

  if (activeToolPageDefinition.id === "vehicle-km-driver") {
    return (
      <VehicleKmDriverPage
        title={activeToolPageDefinition.label}
        onBack={onBack}
        canDeleteRecords={canDeleteVehicleRecords}
        currentUserId={currentUserId}
        currentUserName={currentUserName}
        selectedProjectId={selectedProjectId}
        isOnline={isOnline}
      />
    );
  }

  if (activeToolPageDefinition.id === "fuel") {
    return (
      <FuelWorkspacePage
        title={activeToolPageDefinition.label}
        description={activeToolPageDefinition.description}
        onBack={onBack}
        canDeleteRecords={canDeleteVehicleRecords}
        currentUserId={currentUserId}
        selectedProjectId={selectedProjectId}
        isOnline={isOnline}
      />
    );
  }

  if (activeToolPageDefinition.id === "packaging") {
    return (
      <PackagingWorkspacePage
        title={activeToolPageDefinition.label}
        description={activeToolPageDefinition.description}
        onBack={onBack}
        projects={projects}
        selectedProjectId={selectedProjectId}
        isOnline={isOnline}
      />
    );
  }

  return (
    <ToolWorkspacePage
      title={activeToolPageDefinition.label}
      description={activeToolPageDefinition.description}
      onBack={onBack}
    />
  );
}
